import React, { useCallback, useEffect, useMemo, useState } from "react";

import { Link } from "react-router-dom";
import { FiPlusCircle, FiEye, FiInfo } from "react-icons/fi";
import { getMedicalStatusClass, MD_STATUS } from "./Constant";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";

// import { incidentFilterFields, validateRowFilter } from "./CONSTANTS";

import BackBtn from "app/Components/CommanComponents/BackBtn";

import {
  isUserRO,
  isUserMM,
  isUserSO,
  isUserInvestigator,
  isUserMedicalOfficer,
} from "../IncidentManagement/Helper";
import { useForm } from "app/_helpers/hooks";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import {
  capitalLabel,
  medicalFilterFields,
  MEDICAL_REPORT_STATUS,
  MEDICAL_STATUS,
  validateMedicalRowFilter,
} from "./Constant";
import moment from "moment";
import { getAllMedicalHistory } from "app/_services/ehs/MedicalService";
import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import FilterBtn from "app/Components/CommanComponents/FilterBtn";
import MedicalFilters from "./Component/MedicalFilters";
import { DDMMYYYYFormat } from "app/_helpers/dateHelper";
import { downloadFileByURL } from "app/_helpers/reactHelper";
import { URL_CONFIG } from "app/_constants/Config/URL_CONFIG";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { ACTIVE_MODULE } from "app/_constants/constant";
import { capitalizeName } from "app/_helpers/helper";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";
const { SearchBar } = Search;

function MyApprovalHistoryMedical({
  match: {
    params: { siteId },
  },
}) {
  const [tab, setTab] = useState(0);
  const [incidents, setIncidents] = useState([]);
  const [incidentsFilter, setIncidentsFilter] = useState([]);
  //const [filterForm, onChangeFilter, setFilterForm] = useForm({});
  const [showFilter, setShowFilter] = useState(false);
  const [filterForm, setFilterForm] = useState({});
  const [loading, setLoading] = useState(true);

  const rowStyle = useCallback((row) => {
    if (row.isBack) {
      return { backgroundColor: "#d2ced6" };
    }
  }, []);

  const onReset = () => setFilterForm({ formA: "" });

  const onChange = ({ target: { name, value } }) => {
    setFilterForm((prev) => {
      if (name === "medicalAssigneeTypeView") {
        prev.assigneeName = "";
        prev.assigneeID = "";
      }
      return { ...prev, [name]: value };
    });
  };

  const downloadPdf = async (id) => {
    // const data = await downloadMedicalCertificate(id);
    downloadFileByURL(
      URL_CONFIG.DEV_URL +
        "global-configuration/ehs-module/download-medical-certificate/" +
        id,
      `medical-certificate-${new Date().toISOString()}.pdf`
    );

    // console.log("data", data);
  };

  //const onReset = useCallback(() => setFilterForm({}), [setFilterForm]);

  const sortableColumn = useMemo(() => {
    const column = [
      {
        dataField: "sid",
        text: "S.No.",
        sort: true,
      },
      {
        dataField: "locationName",
        text: "Location",
        sort: true,
      },
      {
        dataField: "medicalTestTypeView",
        text: "Exam",
        sort: true,
      },
      {
        dataField: "medicalAssigneeTypeView",
        text: "Staff Type",
        sort: true,
      },
      {
        dataField: "assigneeName",
        text: "Name",
        sort: true,
        formatter: (status, row) => {
          return <div>{capitalizeName(row?.assigneeName)}</div>;
        },
      },
      {
        dataField: "assigneeID",
        text: "ID",
        sort: true,
      },
      {
        dataField: "formA",
        text: "Form A",
        sort: true,
      },
      // {
      //   dataField: "dueDateView",
      //   text: "Due Date",
      //   sort: true,
      // },
      {
        dataField: "medicalStatusView",
        text: "Status",
        sort: true,
        // formatter: (val) => capitalLabel(val),
        formatter: (status, row) => {
          return <div className={getMedicalStatusClass(status)}>{status}</div>;
        },
      },
      {
        dataField: "medicalResult",
        text: "Report Status",
        sort: true,
        formatter: (val) => (val ? capitalLabel(val) : "In Progress"),
        formatter: (status, row) => {
          return <div className={getMedicalStatusClass(status)}>{status}</div>;
        },
      },
      {
        dataField: "certificateId",
        text: "Certificate",
        sort: true,
        formatter: (id, row) => {
          return (
            <div className="actionIconsGroup">
              {row?.medicalStatus === MEDICAL_STATUS.approved &&
                row?.medicalResult === MEDICAL_REPORT_STATUS.fit &&
                isUserMedicalOfficer() && (
                  <CustomTooltip tooltip={"Certificate"}>
                    <span
                      // href={
                      //   (row?.medicalTestType.toLowerCase() === "sme"
                      //     ? "/health-safety-and-environment/medical-management/sme-certificate/"
                      //     : "/health-safety-and-environment/medical/certificate/") +
                      //   row?.id
                      // }
                      // target="_blank"
                      // rel="noopener noreferrer"
                      onClick={() => downloadPdf(row?.id)}
                      className="icons text-cyanBlue"
                    >
                      <FiInfo style={{ color: "rgb(21 239 21)" }} />
                    </span>
                  </CustomTooltip>
                )}
            </div>
          );
        },
      },
      {
        dataField: "completionDate",
        text: "Exam Date",
        sort: true,
        //formatter: (date, row) => moment(row?.examDate).format("DD-MM-YYYY"),
        formatter: (date, row) =>
          row?.completionDate ? DDMMYYYYFormat(row?.completionDate) : row?.completionDate,
      },

      {
        dataField: "create",
        text: "Action",
        formatter: (rowContent, row) => {
          return (
            <div className="actionIconsGroup">
              <CustomTooltip tooltip={"View"}>
                <Link
                  to={"/health-safety-and-environment/medical/view/" + row.id}
                  className="icons text-cyanBlue"
                >
                  <FiEye />
                </Link>
              </CustomTooltip>
            </div>
          );
        },
      },
    ];

    return column;
  }, []);

  /**************** useEffect *************/
  useEffect(() => {
    // getAllMedicalHistory(siteId ? `filter[siteId]=${siteId}` : "").then((response) => {
    //   if (!response?.data) return;
    //   console.log("6666666666666", response?.data);
    //   response.data.medicalOfficer = response?.data?.medicalOfficer?.map((d) => {
    //     return { ...d, locationName: d?.ehsSite ? d?.ehsSite?.name : "" };
    //   });
    //   response.data.safetyOfficer = response?.data?.safetyOfficer?.map((d) => {
    //     return { ...d, locationName: d?.ehsSite ? d?.ehsSite?.name : "" };
    //   });
    //   response.data.minesManager = response?.data?.minesManager?.map((d) => {
    //     return { ...d, locationName: d?.ehsSite ? d?.ehsSite?.name : "" };
    //   });
    //   setIncidents(response.data);
    // });

    const fetchData = async () => {
      try {
        const response = await getAllMedicalHistory(
          siteId ? `filter[siteId]=${siteId}` : ""
        );
        if (!response?.data) {
          // Handle the case where data is not received
          setLoading(false);
          return;
        }
        response.data.medicalOfficer = response?.data?.medicalOfficer?.map((d) => {
          return { ...d, locationName: d?.ehsSite ? d?.ehsSite?.name : "" };
        });
        response.data.safetyOfficer = response?.data?.safetyOfficer?.map((d) => {
          return { ...d, locationName: d?.ehsSite ? d?.ehsSite?.name : "" };
        });
        response.data.minesManager = response?.data?.minesManager?.map((d) => {
          return { ...d, locationName: d?.ehsSite ? d?.ehsSite?.name : "" };
        });
        setIncidents(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        // Handle error as needed, e.g., show an error message
        setLoading(false);
      }
    };

    fetchData();
  }, [siteId]);

  useEffect(() => {
    let data = [];
    if (tab === 1) {
      data = incidents?.medicalOfficer || [];
    }
    if (tab === 2) {
      data = incidents?.safetyOfficer || [];
    }
    if (tab === 3) {
      data = incidents?.minesManager || [];
    }

    // let result = data.filter((row) => validateRowFilter(filterForm, row));

    setIncidentsFilter(
      data?.filter?.((obj) => {
        return validateMedicalRowFilter(obj, filterForm);
      })
    );
  }, [
    filterForm,
    incidents?.medicalOfficer,
    incidents?.minesManager,
    incidents?.safetyOfficer,
    tab,
  ]);

  useEffect(() => {
    setTab(
      incidents?.medicalOfficer?.length
        ? 1
        : incidents?.safetyOfficer?.length
        ? 2
        : incidents?.minesManager?.length
        ? 3
        : 0
    );
  }, [
    incidents?.medicalOfficer?.length,
    incidents?.minesManager?.length,
    incidents?.safetyOfficer?.length,
  ]);

  const tableToolbarBeforeView = () =>
    showFilter && (
      <MedicalFilters
        fields={medicalFilterFields}
        setForm={setFilterForm}
        form={filterForm}
        onChange={onChange}
        onReset={onReset}
      />
    );

  return (
    <>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "Personnel Health Management",
            path: "/health-safety-and-environment/medical",
          },
          { name: "My Approval History" },
        ]}
        module={ACTIVE_MODULE.personnelHealthManagement}
      />
      <div className="card p-3">
        <div className="simple-card-title cardCustomHeader">
          <h3 class="text-capitalize mb-0">My Approval History</h3>
          <FilterBtn setShowFilter={setShowFilter} />
          {/* <button
          className="btn btn-outline-primary filterBtn"
          onClick={() => {
            setShowFilter((prev) => !prev);
          }}
        >
          <i className="i-Filter-2"></i>Filter
        </button> */}
          <BackBtn url={"/health-safety-and-environment/medical"} />
        </div>

        <div className="healthSafetyEnvironmentWrapper EHS_module_tabber mb-3">
          <div className="hseMenuLinks card">
            {incidents?.medicalOfficer?.length > 0 && (
              <a
                href
                onClick={() => setTab(1)}
                className={`pointer${tab === 1 ? " active" : ""}`}
              >
                Medical Officer
              </a>
            )}

            {incidents?.safetyOfficer?.length > 0 && (
              <a
                href
                onClick={() => setTab(2)}
                className={`pointer${tab === 2 ? " active" : ""}`}
              >
                Safety Officer
              </a>
            )}
            {incidents?.minesManager?.length > 0 && (
              <a
                href
                onClick={() => setTab(3)}
                className={`pointer${tab === 3 ? " active" : ""}`}
              >
                Mines Manager
              </a>
            )}
          </div>
        </div>
        {!loading ? (
          <SearchBootstrapTable
            searchKey={"MyApprovalHistoryMedicalDesktopSearch"}
            data={incidentsFilter?.map((d, i) => ({ ...d, sid: i + 1 }))}
            columns={sortableColumn}
            tableBeforeSearch={tableToolbarBeforeView}
            // tableToolbarView={tableToolbarView}
            // downloadPermission={"global_globalConfiguration_download"}
            tableKey="MyApprovalHistoryMedical"
          />
        ) : (
          <NetZeroLoader />
        )}
      </div>
    </>
  );
}

export default MyApprovalHistoryMedical;
